// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .welcome-dialog {
    position: relative;
    background-color: #242b37;
    border: 1px solid #0096a1;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 90px 20px 20px; /* Increased top padding */
    width: 400px;
    font-family: Kim;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    color: white;
  }
  
  .welcome-logo {
    position: absolute;
    top: -100px; /* Adjusted to move the logo up */
    left: 50%;
    transform: translateX(-50%);
    width: 250px; /* Reduced size */
    height: auto;
    z-index: 1;
  }
  
  .dialog-content {
    margin-top: 10px; /* Reduced top margin */
  }

  .welcome-header {
    font-size: 16px;
    color: white;
  }
  
  .login-header {
    font-size: 14px;
    color: white;
  }
  
  .login-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }



  .sign-up-btn, .explore-btn {
    border-radius: 8px; /* Rounded corners */
    color: #ffffff;
    margin: 10px 0; /* Vertical margin for spacing between buttons */
    cursor: pointer;
    width: 80%; /* Adjust width as needed */
    text-align: center;
    transition: all 0.3s ease; /* Smooth hover and active transition */
    font-family: Kim;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.sign-up-btn {
    background-color: #ffcc00; /* Golden color */
    border: 2px solid #ffaa00; /* Slightly darker border for depth */
    font-size: 18px;
    padding: 12px 24px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Depth effect */
}

.explore-btn {
    background-color: #e6b800; /* Slightly less vibrant gold */
    border: 1px solid #cc9900; /* Thinner, less contrasty border */
    font-size: 14px;
    padding: 8px 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Less pronounced shadow */
}

.sign-up-btn:hover {
    background-color: #ffaa00; /* Slightly darker on hover */
    border-color: #ff9900; /* Darker border on hover */
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15); /* Deeper shadow on hover */
}

.explore-btn:hover {
    background-color: #d9ad00; /* Less dramatic hover effect */
    border-color: #bf9900;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.12);
}

.sign-up-btn:active, .explore-btn:active {
    transform: scale(0.95); /* Scale down on press */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Less shadow on press */
}


.back-button {
    background-color: #cccccc;
    border: none;
    border-radius: 4px;
    color: #333333;
    font-size: 14px;
    margin-top: 20px;
    padding: 10px 20px;
    cursor: pointer;
    width: 50%; /* Adjust width as needed */
    text-align: center;
  }
  
  .back-button:hover {
    opacity: 0.8;
  }`, "",{"version":3,"sources":["webpack://./src/components/popups/welcome/Welcome.style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB,EAAE,0BAA0B;IACnD,YAAY;IACZ,gBAAgB;IAChB,iEAAiE;IACjE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW,EAAE,iCAAiC;IAC9C,SAAS;IACT,2BAA2B;IAC3B,YAAY,EAAE,iBAAiB;IAC/B,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,gBAAgB,EAAE,uBAAuB;EAC3C;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;;;EAIA;IACE,kBAAkB,EAAE,oBAAoB;IACxC,cAAc;IACd,cAAc,EAAE,gDAAgD;IAChE,eAAe;IACf,UAAU,EAAE,2BAA2B;IACvC,kBAAkB;IAClB,yBAAyB,EAAE,uCAAuC;IAClE,gBAAgB;IAChB,iEAAiE;AACrE;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,yBAAyB,EAAE,qCAAqC;IAChE,eAAe;IACf,kBAAkB;IAClB,wCAAwC,EAAE,iBAAiB;AAC/D;;AAEA;IACI,yBAAyB,EAAE,+BAA+B;IAC1D,yBAAyB,EAAE,mCAAmC;IAC9D,eAAe;IACf,iBAAiB;IACjB,wCAAwC,EAAE,2BAA2B;AACzE;;AAEA;IACI,yBAAyB,EAAE,6BAA6B;IACxD,qBAAqB,EAAE,2BAA2B;IAClD,yCAAyC,EAAE,2BAA2B;AAC1E;;AAEA;IACI,yBAAyB,EAAE,+BAA+B;IAC1D,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB,EAAE,wBAAwB;IAChD,wCAAwC,EAAE,yBAAyB;AACvE;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,UAAU,EAAE,2BAA2B;IACvC,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd","sourcesContent":[".welcome-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .welcome-dialog {\n    position: relative;\n    background-color: #242b37;\n    border: 1px solid #0096a1;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    padding: 90px 20px 20px; /* Increased top padding */\n    width: 400px;\n    font-family: Kim;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n    color: white;\n  }\n  \n  .welcome-logo {\n    position: absolute;\n    top: -100px; /* Adjusted to move the logo up */\n    left: 50%;\n    transform: translateX(-50%);\n    width: 250px; /* Reduced size */\n    height: auto;\n    z-index: 1;\n  }\n  \n  .dialog-content {\n    margin-top: 10px; /* Reduced top margin */\n  }\n\n  .welcome-header {\n    font-size: 16px;\n    color: white;\n  }\n  \n  .login-header {\n    font-size: 14px;\n    color: white;\n  }\n  \n  .login-buttons {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 20px;\n  }\n\n\n\n  .sign-up-btn, .explore-btn {\n    border-radius: 8px; /* Rounded corners */\n    color: #ffffff;\n    margin: 10px 0; /* Vertical margin for spacing between buttons */\n    cursor: pointer;\n    width: 80%; /* Adjust width as needed */\n    text-align: center;\n    transition: all 0.3s ease; /* Smooth hover and active transition */\n    font-family: Kim;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.sign-up-btn {\n    background-color: #ffcc00; /* Golden color */\n    border: 2px solid #ffaa00; /* Slightly darker border for depth */\n    font-size: 18px;\n    padding: 12px 24px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Depth effect */\n}\n\n.explore-btn {\n    background-color: #e6b800; /* Slightly less vibrant gold */\n    border: 1px solid #cc9900; /* Thinner, less contrasty border */\n    font-size: 14px;\n    padding: 8px 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Less pronounced shadow */\n}\n\n.sign-up-btn:hover {\n    background-color: #ffaa00; /* Slightly darker on hover */\n    border-color: #ff9900; /* Darker border on hover */\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15); /* Deeper shadow on hover */\n}\n\n.explore-btn:hover {\n    background-color: #d9ad00; /* Less dramatic hover effect */\n    border-color: #bf9900;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.12);\n}\n\n.sign-up-btn:active, .explore-btn:active {\n    transform: scale(0.95); /* Scale down on press */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Less shadow on press */\n}\n\n\n.back-button {\n    background-color: #cccccc;\n    border: none;\n    border-radius: 4px;\n    color: #333333;\n    font-size: 14px;\n    margin-top: 20px;\n    padding: 10px 20px;\n    cursor: pointer;\n    width: 50%; /* Adjust width as needed */\n    text-align: center;\n  }\n  \n  .back-button:hover {\n    opacity: 0.8;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
